import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

export type ShiftEventType = 'shiftStarted' | 'lunchStarted' | 'lunchEnded' | 'shiftEnded';

export type DriverRole = 'driver' | 'driverAssistant' | 'pedestrian';

export interface ShiftCoords {
  lat: number;
  lon: number;
}

export interface ShiftEvent {
  _id: string;
  admin: string;
  adminLogin: string;
  type: ShiftEventType;
  /**
   * Only shiftStarted/shiftEnded carry a location, and the backend stores it
   * nested rather than as top-level lat/lon (ecos-back Driver.js:139).
   */
  coords?: ShiftCoords;
  createdAt: string;
  updatedAt: string;
}

export interface DayStats {
  _id: string;
  admin: string;
  date: string;
  actionsCount: number;
  adminLogin: string;
  bonus: number;
  workingMinutes: number;
  createdAt: string;
  updatedAt: string;
}

export interface DayStatsResponse {
  data: { stats: DayStats[] };
  pagination: {
    limit: number;
    page: number;
    totalPages: number;
    count: number;
  };
}

export interface ShiftEventsResponse {
  data: { adminShiftEvents: ShiftEvent[] };
  pagination: {
    limit: number;
    page: number;
    totalPages: number;
    count: number;
  };
}

export interface GetAllDayStatsParams {
  dateFrom: string;
  dateTo: string;
  adminId?: string;
  page?: number;
  limit?: number;
}

export interface GetShiftEventsParams {
  page?: number;
  limit?: number;
  adminId?: string;
  dateFrom?: string;
  dateTo?: string;
}

export const shiftsApi = createApi({
  reducerPath: 'shiftsApi',
  baseQuery,
  tagTypes: ['AllStats', 'ShiftEvents'],
  endpoints: builder => ({
    getAllDayStats: builder.query<DayStatsResponse, GetAllDayStatsParams>({
      query: params => ({
        url: 'drivers/all_day_stats',
        params
      }),
      providesTags: ['AllStats']
    }),
    getShiftEvents: builder.query<ShiftEventsResponse, GetShiftEventsParams>({
      query: params => ({
        url: 'drivers/shift_events',
        params
      }),
      providesTags: ['ShiftEvents']
    })
  })
});

export const {
  useGetAllDayStatsQuery,
  useGetShiftEventsQuery
} = shiftsApi;
